// material-ui

import deleteterminalicon from '../../../assets/images/delete-terminal.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const DeleteTerminalIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={deleteterminalicon} alt="Delete Terminal" width="22"  />
    );
};

export default DeleteTerminalIcon;